// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hourly-forecast {
  padding: var(--spacing-lg);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-lg);
  flex-wrap: wrap;
  gap: var(--spacing-sm);
}

.title-section {
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.card-subtitle {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.rain-alert {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs) var(--spacing-sm);
  background: rgba(59, 130, 246, 0.2);
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  color: var(--accent-blue);
}

.scroll-controls {
  display: flex;
  gap: var(--spacing-xs);
}

.scroll-btn {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
}

.scroll-btn:hover {
  background: var(--bg-card-hover);
  border-color: var(--accent-blue);
  color: var(--accent-blue);
}

.hourly-scroll {
  flex: 1 1;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  margin: 0 calc(-1 * var(--spacing-lg));
  padding: 0 var(--spacing-lg);
}

.hourly-container {
  display: flex;
  gap: var(--spacing-sm);
  padding-bottom: var(--spacing-sm);
}

.hour-card {
  flex: 0 0 auto;
  width: 85px;
  padding: var(--spacing-md) var(--spacing-sm);
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs);
  transition: all var(--transition-fast);
  position: relative;
  cursor: pointer;
  user-select: none;
}

.hour-card:hover {
  background: var(--bg-card-hover);
  transform: translateY(-2px);
  border-color: var(--accent-blue);
}

.hour-card.selected {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.25), rgba(6, 182, 212, 0.25));
  border-color: var(--accent-blue);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.hour-card.now {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(6, 182, 212, 0.2));
  border-color: var(--accent-blue);
}

.hour-time {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.hour-card.now .hour-time {
  color: var(--accent-blue);
}

.hour-icon-container {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hour-icon {
  width: 50px;
  height: 50px;
}

.hour-temp {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

.hour-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 0.7rem;
  color: var(--text-muted);
}

.precip-chance {
  color: var(--accent-blue);
}

.hour-wind {
  color: var(--text-muted);
}

.temp-bar-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--bg-card);
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  overflow: hidden;
}

.temp-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(90deg, var(--accent-blue), var(--accent-orange));
  transition: height var(--transition-normal);
}

/* Expanded detail panel */
.hour-detail-panel {
  margin-top: var(--spacing-md);
  padding: var(--spacing-md);
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(6, 182, 212, 0.08));
  border: 1px solid var(--accent-blue);
  border-radius: var(--radius-md);
  animation: detailSlideIn 0.2s ease-out;
}

@keyframes detailSlideIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hour-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  border-bottom: 1px solid var(--border-color);
}

.hour-detail-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.hour-detail-icon {
  width: 36px;
  height: 36px;
}

.hour-detail-time {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
}

.hour-detail-condition {
  display: block;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.hour-detail-close {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  transition: all var(--transition-fast);
}

.hour-detail-close:hover {
  background: var(--bg-card-hover);
  border-color: var(--accent-blue);
  color: var(--text-primary);
}

.hour-detail-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-sm);
}

@media (max-width: 600px) {
  .hour-detail-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.hour-detail-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs) var(--spacing-sm);
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-color);
}

.hour-detail-item svg {
  color: var(--accent-blue);
  flex-shrink: 0;
}

.hour-detail-label {
  font-size: 0.7rem;
  color: var(--text-muted);
  flex: 1 1;
}

.hour-detail-value {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
}

.hourly-legend {
  display: flex;
  justify-content: center;
  gap: var(--spacing-lg);
  margin-top: var(--spacing-md);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--border-color);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  font-size: 0.75rem;
  color: var(--text-muted);
}

.legend-hint {
  font-style: italic;
  opacity: 0.7;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.legend-dot.temp {
  background: linear-gradient(135deg, var(--accent-blue), var(--accent-orange));
}

.legend-dot.precip {
  background: var(--accent-blue);
}

.no-data {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
}`, "",{"version":3,"sources":["webpack://./src/components/HourlyForecast/HourlyForecast.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,4CAA4C;EAC5C,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,sFAAsF;EACtF,gCAAgC;EAChC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oFAAoF;EACpF,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4EAA4E;EAC5E,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,sFAAsF;EACtF,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B","sourcesContent":[".hourly-forecast {\n  padding: var(--spacing-lg);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-lg);\n  flex-wrap: wrap;\n  gap: var(--spacing-sm);\n}\n\n.title-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.card-subtitle {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.rain-alert {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  background: rgba(59, 130, 246, 0.2);\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  color: var(--accent-blue);\n}\n\n.scroll-controls {\n  display: flex;\n  gap: var(--spacing-xs);\n}\n\n.scroll-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n}\n\n.scroll-btn:hover {\n  background: var(--bg-card-hover);\n  border-color: var(--accent-blue);\n  color: var(--accent-blue);\n}\n\n.hourly-scroll {\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n  margin: 0 calc(-1 * var(--spacing-lg));\n  padding: 0 var(--spacing-lg);\n}\n\n.hourly-container {\n  display: flex;\n  gap: var(--spacing-sm);\n  padding-bottom: var(--spacing-sm);\n}\n\n.hour-card {\n  flex: 0 0 auto;\n  width: 85px;\n  padding: var(--spacing-md) var(--spacing-sm);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-xs);\n  transition: all var(--transition-fast);\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n}\n\n.hour-card:hover {\n  background: var(--bg-card-hover);\n  transform: translateY(-2px);\n  border-color: var(--accent-blue);\n}\n\n.hour-card.selected {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.25), rgba(6, 182, 212, 0.25));\n  border-color: var(--accent-blue);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.hour-card.now {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(6, 182, 212, 0.2));\n  border-color: var(--accent-blue);\n}\n\n.hour-time {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.hour-card.now .hour-time {\n  color: var(--accent-blue);\n}\n\n.hour-icon-container {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hour-icon {\n  width: 50px;\n  height: 50px;\n}\n\n.hour-temp {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.hour-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  font-size: 0.7rem;\n  color: var(--text-muted);\n}\n\n.precip-chance {\n  color: var(--accent-blue);\n}\n\n.hour-wind {\n  color: var(--text-muted);\n}\n\n.temp-bar-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--bg-card);\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n  overflow: hidden;\n}\n\n.temp-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(90deg, var(--accent-blue), var(--accent-orange));\n  transition: height var(--transition-normal);\n}\n\n/* Expanded detail panel */\n.hour-detail-panel {\n  margin-top: var(--spacing-md);\n  padding: var(--spacing-md);\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(6, 182, 212, 0.08));\n  border: 1px solid var(--accent-blue);\n  border-radius: var(--radius-md);\n  animation: detailSlideIn 0.2s ease-out;\n}\n\n@keyframes detailSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hour-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-md);\n  padding-bottom: var(--spacing-sm);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.hour-detail-title {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.hour-detail-icon {\n  width: 36px;\n  height: 36px;\n}\n\n.hour-detail-time {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.hour-detail-condition {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.hour-detail-close {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  color: var(--text-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  transition: all var(--transition-fast);\n}\n\n.hour-detail-close:hover {\n  background: var(--bg-card-hover);\n  border-color: var(--accent-blue);\n  color: var(--text-primary);\n}\n\n.hour-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-sm);\n}\n\n@media (max-width: 600px) {\n  .hour-detail-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.hour-detail-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-color);\n}\n\n.hour-detail-item svg {\n  color: var(--accent-blue);\n  flex-shrink: 0;\n}\n\n.hour-detail-label {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  flex: 1;\n}\n\n.hour-detail-value {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.hourly-legend {\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-lg);\n  margin-top: var(--spacing-md);\n  padding-top: var(--spacing-md);\n  border-top: 1px solid var(--border-color);\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.legend-hint {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.legend-dot.temp {\n  background: linear-gradient(135deg, var(--accent-blue), var(--accent-orange));\n}\n\n.legend-dot.precip {\n  background: var(--accent-blue);\n}\n\n.no-data {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
